module.exports = __webpack_public_path__ + "static/media/popcorn.ed698cc2.svg";